import gql from 'graphql-tag';


export const getDirectory = gql`

subscription getDirectory($id: uuid!){
    directories_by_pk(id:$id){
      id
      description
      name
      email
      phone
      address
      website
      alt_phone
      hobbies
      university_school
      abn_acn
      status
      company_name
      profession
      membership_link
      partnership_link
      business_name
      company_name
      community_status
      community_id
      type
      education
      profession_type
      designation
      working_at
      banner_image
      logo
      latitude
      longitude
      profile_image
      dental_practice_id
      dental_professional_id
      dental_supplier_id

      dental_supplier {
        first_name
        last_name
      }
      dental_practice {
        first_name
        last_name
      }
      dental_professional {
        first_name
        last_name
      }

      directory_documents {
        name
        attachment
      }
      directory_locations {
        id
        media_name
        media_link
        status
        week_name
        clinic_time
      }

      directory_services {
        id
        name
        image
        description
      }
      directory_achievements {
        id
        title
        attachments
      }
      directory_certifications {
        id
        title
        attachments
      }
      directory_appointment_slots {
        id
      }
      directory_team_members(where: { show_in_our_team: { _eq: "true" } }) {
        id
        name
        specialization
        image
        phone
        email
        subrub
        state
        location
      }
      directory_partners {
        name
        description
        image
        attachments
        show_community_user
      }
      directory_gallery_posts {
        id
        image
        before_image
        after_image
        banner_image
        profile_image
        logo
        before_and_after
      }

      directory_testimonials {
        id
        profile_image
        name
        message
        msg_pic
        role
      }

      directory_faqs {
        id
        question
        answer
      }
    }
  }
`;

export const getAllCategories = gql`

subscription getAllCategories {
  directory_categories(order_by: {created_at: desc }){
    id
    name
    image
    directories_aggregate{
      aggregate
      {
        count
      }
    }
  }
}

`;

// query.ts
export const getAllDirectory = gql`
  query getDirectories($limit: Int, $offset: Int, $where: directories_bool_exp) {
    directories(
      where: $where
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      name
      company_name
      logo
      profile_image
      address
      pincode
      status
    }
  }
`;




export const getDirBusinessTypes = gql`

query getDirBusinessTypes {
  directory_business_types{
   id
   name

   directory_categories{
    id
    name
  }

  }
}

`;

// directoryCategories for filter
export const getDirBusinessTypesFiltered = gql`
query getDirBusinessTypes($where: directory_business_types_bool_exp!) {
  directory_business_types(where: $where, order_by: { name: asc }) {
    id
    name
    type
    directory_categories {
      id
      name
    }
  }
}
`;

export const getCatsById = gql`
query getCatsById($id: uuid!){
  directory_categories(where:{directory_business_type_id:{_eq:$id}}) {
    id
    name
    image
    directories_aggregate{
      aggregate
      {
        count
      }
    }

  }
}
`;


export const removeFollwers = gql`
mutation removeFollwers($id: uuid!) {
  delete_directory_followers(where:{
    _or:[{
      dental_supplier_id: {_eq: $id}
    },{
      dental_practice_id: {_eq: $id}
    },{
      dental_professional_id: {_eq: $id}
    }]
  }){
    affected_rows
  }
}
`;


export const practiceFollowing = gql`
subscription follwers($id:uuid!){
  directory_followers(where:{follower_dental_practice_id:{_eq:$id}}){
    id

  }
}
`;

export const professinalFollowing = gql`
subscription follwers($id:uuid!){
  directory_followers(where:{follower_dental_professional_id:{_eq:$id}}){
    id

  }
}
`;

export const supplierFollowing = gql`
subscription follwers($id:uuid!){
  directory_followers(where:{follower_dental_supplier_id:{_eq:$id}}){
    id
    dental_practice{
      id
    }
    dental_professional{
      id
    }
    dental_supplier{
      id
    }

  }
}
`;

export const supplierFollowers = gql`
subscription follwers($id:uuid!){
  directory_followers(where:{dental_supplier_id:{_eq:$id}}){
    id

  }
}
`;

export const practiceFollowers = gql`
subscription follwers($id:uuid!){
  directory_followers(where:{dental_practice_id:{_eq:$id}}){
    id

  }
}
`;

export const professionalFollowers = gql`
subscription follwers($id:uuid!){
  directory_followers(where:{dental_professional_id:{_eq:$id}}){
    id

  }
}
`;


export const getDirectories = gql`
  query getDirectories($limit: Int!, $offset: Int!, $where: directories_bool_exp) {
    directories(
      where: $where
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      name
      type
      status
      pincode
      address
      logo
      profile_image
      company_name
      profession_type
      latitude
      longitude
      created_at
    }
  }
`;





export const getServices = gql`

subscription getServices($id: uuid!){
  directory_appointment_slots(where:{directory_id:{_eq:$id}}) {
    id
    directory_id
    service_name
    directory_service_id
    serviceMember
    day_wise_timeslots
    weekdays
  }
}

`;
export const getTeamMembers = gql`
subscription getTeamMembers($id: uuid!) {
  directory_team_members(where: { directory_id: { _eq: $id } }) {
    id
    name
    specialization
    image
    phone
    email
    subrub
    state
  }
}
`;

export const getBookedSelService = gql`

query getBookedSelService($id: [uuid!]!) {   
  directory_appointments(where: {directory_service_id: {_in: $id}}) { 
    id    
    timeslot    
    directory_service_id
    appointment_date    
    __typename  
  }
}

`;



export const addFollowrs = gql`

mutation addFollowrs($followObj: directory_followers_insert_input!) {
  insert_directory_followers_one(object: $followObj) {
    id
  }
}

`;


export const getFollowersData = gql`

query clientsData($tagIdArray: [uuid!]){
  clients(where:{id:{_in: $tagIdArray}}){
    id
    name
    payload

  }
}
`;


export const getDirectoryFollowersData = gql`
  query GetFollowersData {
    directory_followers {
    id
		following_status
		dental_admin_id
		dental_practice_id
		dental_professional_id
		dental_supplier_id
		follower_dental_practice_id
		follower_dental_professional_id
		follower_dental_supplier_id
		follower_company_id
    }
  }
`;


export const getUserDataStatus = gql`
 query GetDirectoryFollowers($userId: uuid!) {
  directory_followers(
    where: {
      _or: [
        { follower_dental_supplier_id: { _eq: $userId } },
        { follower_dental_practice_id: { _eq: $userId } },
        { follower_dental_professional_id: { _eq: $userId } }
      ]
    }
  ) {
    id
    created_at
    updated_at
    dental_supplier_id
    dental_practice_id
    dental_professional_id
    follower_dental_supplier_id
    follower_dental_practice_id
    follower_dental_professional_id
  
  }
}

`;



export const getUsersData = gql`
query getFollowers($userId: uuid) {
  to_whome_i_am_following_aggregate: directory_followers_aggregate(where: {
    _or: [
      { dental_supplier_id: { _eq: $userId } },
      { dental_practice_id: { _eq: $userId } },
      { dental_professional_id: { _eq: $userId } },
      { dental_admin_id: { _eq: $userId } }
    ],
    following_status: { _eq: "APPROVED" }
  }) {
    aggregate {
      count
    }
  }

  to_whome_i_am_following: directory_followers(where: {
    _or: [
      { dental_supplier_id: { _eq: $userId } },
      { dental_practice_id: { _eq: $userId } },
      { dental_professional_id: { _eq: $userId } },
      { dental_admin_id: { _eq: $userId } }
    ],following_status: { _eq: "APPROVED" }
  }) {
    id
    following_status
    follower_dental_professional_id
    follower_dental_supplier_id
    follower_dental_practice_id
    follower_company_id

    follower_dental_professional {
      id
      name
      profile_image
      type
      
    }
    follower_dental_supplier {
      id
      name
      logo
      type
    }
    follower_dental_practice {
      id
      name
      logo
      type
    }
      follower_company {
    id
    name
    logo
    type
    company_name
  }
   

    dental_supplier {
      id
      name
    }
    dental_practice {
      id
      name
    }
    dental_professional {
      id
      name
    }
    dental_admin {
      id
      name
    }
  }

  who_is_following_aggregate: directory_followers_aggregate(where: {
    _or: [
      { follower_dental_supplier_id: { _eq: $userId } },
      { follower_dental_practice_id: { _eq: $userId } },
      { follower_dental_professional_id: { _eq: $userId } },
       { follower_company_id: { _eq: $userId } }
    ],following_status: { _eq: "APPROVED" }
  }) {
    aggregate {
      count
    }
  }

  who_is_following: directory_followers(where: {
    _or: [
      { follower_dental_supplier_id: { _eq: $userId } },
      { follower_dental_practice_id: { _eq: $userId } },
      { follower_dental_professional_id: { _eq: $userId } },
        { follower_company_id: { _eq: $userId } }
    ],following_status: { _eq: "APPROVED" }
  }) {
    id
    dental_admin_id
    dental_professional_id
    dental_practice_id
    dental_supplier_id
    following_status
    dental_supplier {
      id
      name
    }
    dental_practice {
      id
      name
    }
    dental_professional {
      id
      name
    }
    dental_admin {
      id
      name
    }
  }
}
`;


export const getUsersDataPending = gql`
query getFollowers($userId: uuid) {
  to_whome_i_am_following_aggregate: directory_followers_aggregate(where: {
    _or: [
      { dental_supplier_id: { _eq: $userId } },
      { dental_practice_id: { _eq: $userId } },
      { dental_professional_id: { _eq: $userId } },
      { dental_admin_id: { _eq: $userId } }
    ],
    following_status: { _eq: "APPROVED" }
  }) {
    aggregate {
      count
    }
  }

  to_whome_i_am_following: directory_followers(where: {
    _or: [
      { dental_supplier_id: { _eq: $userId } },
      { dental_practice_id: { _eq: $userId } },
      { dental_professional_id: { _eq: $userId } },
      { dental_admin_id: { _eq: $userId } }
    ],following_status: { _eq: "APPROVED" }
  }) {
    id
    following_status
    follower_dental_professional_id
    follower_dental_supplier_id
    follower_dental_practice_id
    follower_dental_professional {
      id
      name
      profile_image
      type
      
    }
    follower_dental_supplier {
      id
      name
      logo
      type
    }
    follower_dental_practice {
      id
      name
      logo
      type
    }
   

    dental_supplier {
      id
      name
    }
    dental_practice {
      id
      name
    }
    dental_professional {
      id
      name
    }
    dental_admin {
      id
      name
    }
  }

  who_is_following_aggregate: directory_followers_aggregate(where: {
    _or: [
      { follower_dental_supplier_id: { _eq: $userId } },
      { follower_dental_practice_id: { _eq: $userId } },
      { follower_dental_professional_id: { _eq: $userId } }
    ],
  }) {
    aggregate {
      count
    }
  }

  who_is_following: directory_followers(where: {
    _or: [
      { follower_dental_supplier_id: { _eq: $userId } },
      { follower_dental_practice_id: { _eq: $userId } },
      { follower_dental_professional_id: { _eq: $userId } }
    ],,following_status: { _eq: "PENDING" }
  }) {
    id
    dental_admin_id
    dental_professional_id
    dental_practice_id
    dental_supplier_id
    following_status
    dental_supplier {
      id
      name
      type
      logo
    }
    dental_practice {
      id
      name
      type
      logo
    }
    dental_professional {
      id
      name
      type
      profile_image
    }
    dental_admin {
      id
      name
    }
  }
}
`;


export const getUsersFollowing = gql`
  query getFollowers($userId: uuid) {
    who_is_following: directory_followers(where:{
      _or:[
        { dental_supplier_id: { _eq: $userId } },
        { dental_practice_id: { _eq: $userId } },
        { dental_professional_id: { _eq: $userId } },
        { dental_admin_id: { _eq: $userId } }
      ]
    }) {
      id
      follower_dental_professional_id
      follower_dental_supplier_id
      follower_dental_practice_id
      follower_company_id
      following_status
    dental_practice{
      id
      name
      directory_followers{
        id
        follower_dental_professional_id
        follower_dental_supplier_id
        follower_dental_practice_id
        follower_company_id
      }
      business_name
      logo
      type
      profession_type
    }
    dental_professional{
      id
      name
      type
      directory_followers{
        id
        follower_dental_professional_id
        follower_dental_supplier_id
        follower_dental_practice_id
        follower_company_id
      }
      profile_image
      profession_type
    }
    dental_supplier{
      id
      name
      type
      directory_followers{
        id
        follower_dental_professional_id
        follower_dental_supplier_id
        follower_dental_practice_id
        follower_company_id
      }
      business_name
      logo
      profession_type
    }
    dental_admin{
      id
    }
    }
  }
`;














export const getUsersFollowers = gql`

query getFollowers($userId: uuid){

  to_whome_i_am_following: directory_followers(where:{
    _or:[{
      follower_dental_supplier_id: {_eq: $userId}
    },{
      follower_dental_practice_id: {_eq: $userId}
    },{
     follower_dental_professional_id: {_eq: $userId}
    }]
  }){
   id
    dental_practice{
      id
      name
      directory_followers{
        id
        follower_dental_professional_id
        follower_dental_supplier_id
        follower_dental_practice_id

      }
      business_name
      logo
      type
      profession_type

    }
    dental_professional{
      id
      name
      type
      directory_followers{
        id
        follower_dental_professional_id
        follower_dental_supplier_id
        follower_dental_practice_id

      }
      profile_image
      profession_type


    }
    dental_supplier{
      id
      name
      type
      directory_followers{
        id
        follower_dental_professional_id
        follower_dental_supplier_id
        follower_dental_practice_id

      }
      business_name
      logo
      profession_type

    }
  }
}
`;


export const addFollowingDataMutation = gql`mutation insert_directory_followers_one($object: directory_followers_insert_input!){
  insert_directory_followers_one(object:$object){
       id
		created_at
		updated_at
		dental_supplier_id
		dental_practice_id
		dental_professional_id
		follower_dental_supplier_id
		follower_dental_practice_id
		follower_dental_professional_id
    follower_company_id
		dental_admin_id
		following_status
		follower_status

  }
}`;

export const updateFollowingDataMutation = gql`
  mutation UpdateFollowingDataStatus($id: uuid!, $status: String!) {
    update_directory_followers_by_pk(pk_columns: { id: $id }, _set: { following_status: $status }) {
      id
      following_status
    }
  }
`;


export const getFollowingData = gql`
  query getFollowingData($userId: uuid!) {
    user_following(where: { followed_by_user_id: { _eq: $userId } }) {
      following_user_id
    }
  }
`;
export const deleteFollowingDataMutation = gql`
  mutation DeleteFollowRequest($id: uuid!) {
    delete_directory_followers_by_pk(id: $id) {
      id
    }
  }
`;

export const GET_DIRECTORY_BY_ID = gql`
  query GetDirectoryById($id: uuid!) {
    directories(where: { id: { _eq: $id } }) {
      id
      company_name
     name
     logo
     profile_image 
    dental_supplier_id
    dental_professional_id
    dental_practice_id
    dental_supplier{
     id
    name
    profile_image
    logo
    created_at
    }
    dental_professional{
     id
    name
    profile_image
    created_at
    }
    dental_practice{
    id
    name
    profile_image
    logo
    created_at
    }
    }
  }
`;

export const GET_DIRECTORIES_BY_STATUS = gql`
  query GetDirectoriesByStatus($statuses: [String!], $limit: Int!, $offset: Int!) {
    directories(
      where: { status: { _in: $statuses } }
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      company_name
      phone
      email
      website
      logo
      directory_category_id
      profession_type
      status
    }
  }
`;

// export const INSERT_REGISTERED_USER_CLAIM = gql`
//   mutation InsertRegisteredUserClaim($object: registered_user_claim_insert_input!) {
//     insert_registered_user_claim_one(object: $object) {
//       id
//     }
//   }
// `;

export const GET_DIRECTORIES_COUNT = gql`
  query GetDirectoriesCount($statuses: [String!]) {
    directories_aggregate(where: { status: { _in: $statuses } }) {
      aggregate {
        count
      }
    }
  }
`;

// // Get a directory by ID
// export const GET_DIRECTORY_EDIT_ID = gql`
//   query GetDirectoryById($id: uuid!) {
//     directories_by_pk(id: $id) {
//       id
//       company_name
//       phone
//       email
//       website
//       type
//       logo
//       profession_type
//       directory_category_id
//     }
//   }
// `;

// // Update a directory
// export const UPDATE_DIRECTORY = gql`
//   mutation UpdateDirectory($id: uuid!, $changes: directories_set_input!) {
//     update_directories_by_pk(pk_columns: { id: $id }, _set: $changes) {
//       id
//     }
//   }
// `;

// Get a directory by ID
export const GET_REGISTERED_USERS_CLAIM = gql`
  query GetRegisteredUserClaims($directoryId: uuid!, $limit: Int, $offset: Int) {
    registered_user_claim(
      where: { directory_id: { _eq: $directoryId } }
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      directory_id
      company_name
      phone
      email
      abn_number
      notes
      created_at
    }
  }
`;